import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MainPages from "./pages/mainPages";
import AppbarSidebar from "./AppbarSidebar";
import ToolbarButtons from "./ToolbarButtons";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function AppbarSidebarDrawer(props) {
  const {
    controlThemeMode,
    handleFullScreen,
    handlePageNumber,
    handleOpenSelectSubtitlesBox,
    mainPageNumber,
    handleSemiAutoShadowing,
    handleShowSubtitleStyleBox,
    handleOpenSelectVideoBox,
    removeSubtitlesTracks,
  } = props;
  return (
    <>
      {/* <SelectMovie/> */}
      <Box sx={{ display: "flex", width: "100%" }}>
        <CssBaseline />
        <AppbarSidebar
          controlThemeMode={controlThemeMode}
          handlePageNumber={handlePageNumber}
          mainPageNumber={mainPageNumber}
        >
          <ToolbarButtons
            handleFullScreen={handleFullScreen}
            mainPageNumber={mainPageNumber}
            handlePageNumber={handlePageNumber}
            handleOpenSelectVideoBox={handleOpenSelectVideoBox}
            handleOpenSelectSubtitlesBox={handleOpenSelectSubtitlesBox}
            handleShowSubtitleStyleBox={handleShowSubtitleStyleBox}
            handleSemiAutoShadowing={handleSemiAutoShadowing}
            removeSubtitlesTracks={removeSubtitlesTracks}
          />
        </AppbarSidebar>
        <Box
          component="main"
          sx={{ color: "#fffbc5", flexGrow: 1, width: "100%" }}
        >
          <DrawerHeader />
          <MainPages mainPageNumber={mainPageNumber} />
        </Box>
      </Box>
    </>
  );
}
